export default [
  'assembly-us',
  'assembly-mx'
];
